import mixpanel from 'mixpanel-browser';
import { DragonchainConfig } from '../lib/globals';

mixpanel.init(DragonchainConfig.MIXPANEL_TOKEN);
const envCheck = process.env.NODE_ENV === 'production'; // set TRUE for testing

const AnalyticAction = {
  identify: (id) => {
    if (envCheck) {
      mixpanel.identify(id);
    }
  },
  alias: (id) => {
    if (envCheck) {
      mixpanel.alias(id);
    }
  },
  track: (name, props) => {
    if (envCheck) {
      mixpanel.track(name, props);
    }
  },
  people: {
    set: (props) => {
      if (envCheck) {
        mixpanel.people.set(props);
      }
    },
  },
};

export default AnalyticAction;
